module.exports = __webpack_public_path__ + "static/media/vlinder-logo.9400c4eb.png";